// src/pages/Coleta/components/SerialDispositivo.jsx
import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import * as Lucide from 'lucide-react';

/**
 * Número de série do dispositivo que fez a análise. No laboratório as torres são
 * identificadas fisicamente pelo serial, então ele aparece inteiro (sem cortar) e em
 * fonte monoespaçada, para conferir caractere por caractere com a etiqueta.
 *
 * `compacto`: linha única para os cartões do celular, com ícone e rótulo.
 */
export default function SerialDispositivo({ serial, compacto = false }) {
    const valor = serial ? String(serial).trim().toUpperCase() : '';
    const texto = (
        <Typography
            component="span"
            variant="body2"
            sx={{ fontFamily: '"IBM Plex Mono", ui-monospace, "Cascadia Mono", Consolas, monospace', fontWeight: 600, letterSpacing: '0.02em', whiteSpace: 'nowrap' }}
        >
            {valor || '—'}
        </Typography>
    );
    if (!compacto) {
        return valor ? <Tooltip title="Número de série do dispositivo">{texto}</Tooltip> : texto;
    }
    return (
        <Stack direction="row" spacing={0.75} alignItems="center" sx={{ color: 'text.secondary', minWidth: 0 }}>
            <Lucide.Cpu size={14} aria-hidden="true" style={{ flexShrink: 0 }} />
            <Typography component="span" variant="caption" color="text.secondary">Dispositivo</Typography>
            {valor ? <Typography component="span" sx={{ color: 'text.primary' }}>{texto}</Typography> : texto}
        </Stack>
    );
}
